export const HOW_IT_WORKS_HEADING = "How It Works";
export const HOW_IT_WORKS_DESCRIPTION = "Send to 1 or 10,000.";

export const HOW_IT_WORKS_DATA = [
  {
    id: 1,
    title: "Pick a Template",
    description:
      "Pick a template and make it yours! Add a logo, banner, or branded swag to your shop.",
  },
  {
    id: 2,
    title: "Send Points",
    description: "Send points to recipients anywhere (all you need are their email addresses).",
  },
  {
    id: 3,
    title: "Recipients Redeem",
    description:
      "Recipients choose what to redeem from your shop, guaranteeing a gift that’ll hit the mark.",
  },
];
